import React, { useEffect, useState } from 'react';
import '../../../styles/Commons.css';
import { Card, Col, Row, Table, Tag, Avatar, Spin } from "antd";
import { ColumnsType } from "antd/es/table";
import { Escola } from "../../../model/root/Escola";
import { GetUsuarisEscolaById } from '../../../dao/root/GetUsuarisEscolaById';
import Colors from "../../../styles/Colors";
import { UserOutlined } from "@ant-design/icons";

interface ElementProps {
    element: Escola;
    page: string;
}

const UsuarisDeEscolaList: React.FC<ElementProps> = ({ element, page }) => {
    const [coleccio, setDades] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(false);

    async function checkDades() {
    try {
        setLoading(true);
        const dades = await GetUsuarisEscolaById(page, element.id);

        if (!dades?.json) {
            console.error("No s'ha rebut cap JSON vàlid:", dades);
            setDades([]);
            return;
        }
        const parsed = JSON.parse(dades.json);
        const usuarisArray = Array.isArray(parsed.usuaris) ? parsed.usuaris : [];


        setDades(usuarisArray);
    } catch (error) {
        console.error("Error carregant usuaris:", error);
        setDades([]);
    } finally {
        setLoading(false);
    }
}



    useEffect(() => {
        if (element?.id && page) {
            checkDades();
        }
    }, [element?.id, page]);

    const columns: ColumnsType<any> = [
        {
            key: 'id',
            title: 'ID',
            dataIndex: 'id',
            width: 90,
            sorter: (a, b) => a.id - b.id,
        },
        {
            key: 'nom',
            title: 'Nom',
            dataIndex: 'nom',
            
            render: (text: string) => (
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <Avatar
                    size="small"
                    icon={<UserOutlined />}
                    style={{ backgroundColor: Colors.colors.color5 }}
                />
                <span>{text}</span>
                </div>
            ),
        },
        {
            key: 'rols',
            title: 'Rols',
            dataIndex: 'rol',
            render: (rols: any[]) => (
                <>
                {Array.isArray(rols) && rols.length > 0 ? (
                    rols.map((r) => (
                    <Tag key={r.id}  style={{ marginBottom: 4 , color:'black'}}>
                        {r.nom}
                    </Tag>
                    ))
                ) : (
                    <Tag color="default">Sense rol</Tag>
                )}
                </>
            ),
        },

    ];

    return (
        <div style={{display:'flex', justifyContent: 'center', alignItems: 'center'}}>
        <Card bordered style={{width:'80%', backgroundColor:'#F7F7F7'}}>
            
            <h4 className="subsubtitol">Usuaris</h4>
             <Spin spinning={loading} tip="Carregant usuaris...">
                <Table
                    tableLayout="fixed"
                    size="small"
                    columns={columns}
                    dataSource={coleccio}
                    rowKey="id"
                />
                </Spin>
        </Card>
        </div>
    );
};

export default UsuarisDeEscolaList;
